import IncomesItem from "./IncomesItem";

export default IncomesItem;
